export function initReviewsSlider() {
    $('#reviews__slider').slick({
        arrows: true,
        infinite: true,
        speed: 300,
        cssEase: 'linear',
        nextArrow: '.reviews .btn--next',
        prevArrow: '.reviews .btn--prev',
    });

    $('#reviews__slider').on('beforeChange', function(event, slick, currentSlide, nextSlide){
        document.querySelector('.reviews .list__pagination .count').innerHTML = '0' + (nextSlide + 1);
    });
}
